import type { TableEditorBooleanColumnData } from '@stratumn/studio-shared';

const DEFAULT_HEADER = 'Default Boolean Column Header';
export const initialBooleanData: TableEditorBooleanColumnData = {
  title: DEFAULT_HEADER,
  width: 'small',
  isfixedColumn: false,
  required: true,
  cell: {
    view: {
      type: 'boolean'
    }
  },
  isDisplayedByDefault: true
};
